module.exports = __webpack_public_path__ + "e12.no2.504ee747.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e12.no2.jpg
// module id = fq0O
// module chunks = 0